import React from 'react'
import HeaderInfoBox from '@Components/ContactUsHeader/HeaderInfoBox'
import { ICONS } from '@Const/common'
import './index.scss'

const ContactUsHeader = () => (
    <div className="contact-us-header">
        <h2>Need Help?</h2>
        <h5>You&apos;ve come to the right place!</h5>
        <span>
            Check out our{' '}
            <a href="//help.themlc.com/en/support" target="_blank" rel="noreferrer">
                Help Center{' '}
            </a>
            or{' '}
            <a href="//themlc.com/frequently-asked-questions" target="_blank" rel="noreferrer">
                FAQ page{' '}
            </a>
            - the answer you&apos;re looking for might be there already!
        </span>
        <span>
            Register{' '}
            <a href="//help.themlc.com/_hcms/mem/register" target="_blank" rel="noreferrer">
                here{' '}
            </a>
            to access{' '}
            <a href="//help.themlc.com/tickets" target="_blank" rel="noreferrer">
                The MLC Ticket Portal{' '}
            </a>
            where you can easily see and manage all your support conversations in one place.
        </span>
        <span>
            If you need additional help, send us an email, chat, or give us a call. The MLC Support Team is available
            Monday-Friday, 8 a.m.-6 p.m. CT.
        </span>
        <div className="header-info-box-section">
            <HeaderInfoBox
                buttonLink="//help.themlc.com/en/support"
                buttonText="Visit Help Center"
                heading="Visit Help Center"
                imageType={ICONS.questionBlue}
                isButton
            >
                <span>Find immediate answers in our help articles.</span>
            </HeaderInfoBox>
            <HeaderInfoBox
                buttonText="Chat with us"
                heading="Chat with us"
                imageType={ICONS.chatBubble}
                onClick={() => window.HubSpotConversations.widget.open()}
                isButton
                btnClassName="mlc-launch-chat"
            />
            <HeaderInfoBox heading="Call us" imageType={ICONS.phoneBlue}>
                <p>Talk to a live team member.</p>
                <strong>
                    <a href="tel:6154883653">(615) 488-3653</a>
                </strong>
            </HeaderInfoBox>
        </div>
    </div>
)

export default ContactUsHeader
